import { fastTrackStatus } from '@helpers/fast_tracks';

const DEFAULT_FAST_TRACK_NAME = 'New Narrative';

export const EMPTY_DOWNLOAD_MAP = new Map();

/**
 * Formats a date string to a label.
 * @param {string} isoDate - The ISO date string.
 * @returns {string|null} - The formatted date label or null if the date is invalid.
 */
const formatDateLabel = (isoDate) => {
  if (!isoDate) return null;
  const date = new Date(isoDate);
  if (Number.isNaN(date.getTime())) return null;
  return date.toLocaleDateString('en-US', { day: 'numeric', month: 'short', year: 'numeric' });
};

/**
 * Builds a flow data object for a draft flow state.
 * @param {Object} flowState - The flow state object.
 * @returns {Object|null} - The flow data object or null if flowState is not provided.
 */
export const buildDraftFlowData = (flowState) => {
  if (!flowState) return null;

  return {
    answers: {
      ...(flowState?.readOnlyPromptAnswers || {}),
      ...(flowState?.editablePromptAnswers || {}),
    },
    createdDatetime: formatDateLabel(flowState?.createdDatetime || flowState?.dateRangeStart),
    fast_track_id: null,
    fastTrackName: DEFAULT_FAST_TRACK_NAME,
    id: null,
    isReadOnly: true,
    name: flowState?.businessQuestion || 'New Narrative',
    topics: [],
  };
};

/**
 * Builds topic data for a draft component.
 * @param {Object} draft - The draft component object.
 * @returns {Object} - The topic data object.
 */
export const buildDraftTopicData = (draft) => {
  const dataset = {
    ...draft.dataset,
    clean_title: draft.title,
    readAs: draft.readAs,
    title: draft.title,
    type: draft.dataset?.type,
  };

  return {
    error: false,
    isHidden: false,
    loading: false,
    tags: {},
    title: draft.title,
    topicId: null,
    visualization: {
      clean_title: draft.title,
      datasets: [dataset],
    },
  };
};

/**
 * Builds a topic shell object for a draft component.
 * @param {Object} draft - The draft component object.
 * @returns {Object} - The topic shell object.
 */
export const buildTopicShell = (draft) => ({
  feedback: {},
  id: draft.componentId,
  isHidden: false,
  status: fastTrackStatus.COMPLETED,
  tags: {},
  title: draft.title,
});
